import {inlineError} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import UserNotLoggedInUserError from '../Errors/UserNotLoggedInUserError.js'

/**
 * @implements UseCase
 */
export class UpdateConsentsUserUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Service} deps.service
   */
  constructor({getCurrentUserService, httpUserRepository, sessionStorageUserRepository}) {
    super()

    this._getCurrentUserService = getCurrentUserService
    this._httpUserRepository = httpUserRepository
    this._sessionStorageUserRepository = sessionStorageUserRepository
  }

  /**
   * @return {Array<Object, Error>} returns consents status of current user or error
   * @property {Object} userConsentsStatusUserValueObject
   */
  @inlineError
  async execute(userConsentsStatusUserValueObject) {
    const userEntity = await this._getCurrentUserService.execute()

    const [error] = await this._httpUserRepository.updateConsents({
      userConsentsStatusUserValueObject,
      userEntity
    })

    if (error instanceof UserNotLoggedInUserError) {
      const [errorSessionStorage, responseSessionStorage] =
        await this._sessionStorageUserRepository.updateConsentsStatus({
          userConsentsStatusUserValueObject
        })

      if (errorSessionStorage) throw errorSessionStorage

      return responseSessionStorage
    }

    if (error) throw error

    return userConsentsStatusUserValueObject
  }
}
